import { callUri } from './utils';
/**
 * Dispatch message to client
 *
 */
export default (function (msg) {
    callUri(msg);
});
//# sourceMappingURL=dispatch.js.map